import { render, staticRenderFns } from "./DefectReport.vue?vue&type=template&id=4a9c96b3&scoped=true&"
import script from "./DefectReport.vue?vue&type=script&lang=js&"
export * from "./DefectReport.vue?vue&type=script&lang=js&"
import style0 from "./DefectReport.vue?vue&type=style&index=0&id=4a9c96b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c96b3",
  null
  
)

export default component.exports